import { ajax } from 'cadenza/api-client/api';
import type { WorkOrderId } from 'cadenza/api-client/workorder-api';
import { MIMETYPE_JSON } from 'cadenza/model/media-type';
import type { ObjecttypeId } from 'cadenza/repository/model/objecttype-id.gen';
import type { PublicationStage } from 'cadenza/repository/model/publication-stage.gen';
import type { RepositoryName } from 'cadenza/repository/model/repository-name.gen';
import type { WorkbookId } from 'cadenza/repository/model/workbook-id.gen';
import type { WorkbookName } from 'cadenza/repository/model/workbook-name.gen';
import type { ValidationItemLabel } from 'cadenza/testsuite/types';
import type { WorkbookVersion } from 'cadenza/workbook/api/workbook-version';

type ValidationSegmentMode = 'VALIDATE_REPOSITORY' | 'VALIDATE_GENERAL_CADENZA';
export interface ValidationSegment {
  mode: ValidationSegmentMode;
  identifier: string;
  label: ValidationItemLabel;
}

export function runTestsuiteForRepository(
  repositoryName: RepositoryName,
  publicationStage: PublicationStage,
  signal: AbortSignal,
) {
  return ajax<WorkOrderId>(
    `/repositories/${repositoryName}/validation-work-orders?defaultRepositoryPublicationStage=${publicationStage}`,
    {
      type: 'POST',
      contentType: MIMETYPE_JSON,
      signal,
    },
  );
}

export function runTestsuiteForGeneralCadenza(signal: AbortSignal) {
  return ajax<WorkOrderId>('/validation-work-orders', {
    type: 'POST',
    contentType: MIMETYPE_JSON,
    signal,
  });
}

export function runTestsuiteForWorkbook(
  { repositoryName, itemName }: WorkbookId,
  publicationStage: PublicationStage,
  signal: AbortSignal,
) {
  return ajax<WorkOrderId>(
    `/repositories/${repositoryName}/workbooks/${itemName}/validation-work-orders?defaultRepositoryPublicationStage=${publicationStage}`,
    {
      type: 'POST',
      contentType: MIMETYPE_JSON,
      signal,
    },
  );
}

export function runTestsuiteForWorkbooksForObjecttype(
  workbookNames: WorkbookName[],
  publicationStage: PublicationStage,
  objecttypeIdToPublish: ObjecttypeId,
  signal: AbortSignal,
) {
  return ajax<WorkOrderId>(
    `/workbooks;workbookNames=${workbookNames.join()}/validation-work-orders?defaultRepositoryPublicationStage=${publicationStage}`,
    {
      type: 'POST',
      contentType: MIMETYPE_JSON,
      signal,
      data: JSON.stringify(objecttypeIdToPublish),
    },
  );
}

export function runTestsuiteForVersionedWorkbook(
  { repositoryName, itemName }: WorkbookId,
  workbookVersion: WorkbookVersion,
  publicationStage: PublicationStage,
  signal: AbortSignal,
) {
  return ajax<WorkOrderId>(
    `/repositories/${repositoryName}/workbooks/${itemName}/versions/${workbookVersion}/validation-work-orders?defaultRepositoryPublicationStage=${publicationStage}`,
    {
      type: 'POST',
      contentType: MIMETYPE_JSON,
      signal,
    },
  );
}

export function getValidationSegments(): Promise<ValidationSegment[]> {
  return ajax<ValidationSegment[]>('/admin/tests/validation-segments/');
}
